import { formatMoney } from 'betterplace-utils'
import React, { useEffect, useState } from 'react'
import iconCount from './donations_count.svg'
import iconSum from './donations_sum.svg'
import iconSubscriptions from './newsletter_subscriptions.svg'
import iconRecurring from './recurring_donations.svg'
import { KpiIconProps, KpiList, KpiOverviewProps } from './types'
import { JSONFetcher } from 'src/shared'

export const KpiOverview = ({ apiUrl }: KpiOverviewProps): JSX.Element => {
  const [kpis, setKpis] = useState(/** @type {KpiList}*/ [] as KpiList)

  // Fetch data
  useEffect(() => {
    JSONFetcher.put({
      url: apiUrl,
      success: (response: { kpis: KpiList }) => setKpis(response.kpis),
    })
  }, [apiUrl])

  return (
    <div className="container-fluid p-0">
      <div className="row row-eq-height">
        {kpis.map((kpi) => (
          <div key={kpi.name} className="col-24 col-md-6 mb-4">
            <div
              className="bg-gray-200 rounded-sm flex desktop:flex-col border border-gray-200 h-full"
              style={{ minHeight: '180px' }}
            >
              <div className="bg-white flex justify-center p-4">
                <KpiIcon kpi={kpi.name} />
              </div>
              <div className="flex flex-col p-6">
                <span className="text-2xl font-bold">
                  {kpi.name === 'sum' ? formatMoney(i18n.locale, kpi.current / 100) : kpi.current}
                </span>
                <span className="font-bold mb-2">{i18n.t(`manage.kpi_overview.label_${kpi.name}`)}</span>
                <span>
                  <span>{kpi.name === 'sum' ? formatMoney(i18n.locale, kpi.previous / 100) : kpi.previous}</span>{' '}
                  <span>{i18n.t(`manage.kpi_overview.period_${kpi.period}`)}</span>
                </span>
                {Math.round(kpi.increase) !== 0.0 && (
                  <div className="w-full text-2xl font-bold mt-2 text-purple-600">
                    {Math.round(kpi.increase) >= 0 && <span>+</span>}
                    {Math.round(kpi.increase)}
                    <span>&#8239;%</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

const KpiIcon = ({ kpi }: KpiIconProps): JSX.Element | null => {
  if (kpi === 'sum') return <img className="desktop:h-full" src={iconSum} alt="" />
  if (kpi === 'count') return <img className="desktop:h-full" src={iconCount} alt="" />
  if (kpi === 'recurring_donations_count') return <img className="desktop:h-full" src={iconRecurring} alt="" />
  if (kpi === 'subscriptions_count') return <img className="desktop:h-full" src={iconSubscriptions} alt="" />
  return null
}
